



















import { Component, Ref, Vue } from 'vue-property-decorator'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import DialogoDeEdicaoDeWebhook from '@/components/webhooks/DialogoDeEdicaoDeWebhook.vue'
import DocumentacaoDeWebhook from '@/components/webhooks/DocumentacaoDeWebhook.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { FormWebhook, Webhook } from '@/models'
import { DeleteWebhookUseCase, FindWebhookUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component({
	components: {
		DataTableDeCrud,
		DialogoDeEdicaoDeWebhook,
		DocumentacaoDeWebhook,
		Confirmacao,
	},
})
export default class TelaDeWebhooks extends Vue {
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDeWebhook
	@Ref() confirmacaoExclusao!: Confirmacao

	webhooks: Webhook[] = []
	carregando = false
	findUseCase = new FindWebhookUseCase()
	deleteUseCase = new DeleteWebhookUseCase()

	headers = [
		{ text: 'URL', value: 'url' },
		{ text: 'Eventos', value: 'displayEventos' },
		{ text: 'Ativo', value: 'displayAtivo' },
	]

	created() {
		this.buscar()
	}

	async buscar() {
		try {
			this.carregando = true
			this.webhooks = await this.findUseCase.listar()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	get webhooksFormatados() {
		return this.webhooks.map(webhook => ({
			...webhook,
			displayEventos: (webhook.eventos || []).join(', '),
			displayAtivo: webhook.ativo ? 'Sim' : 'Não',
		}))
	}

	atualizarWebhook(webhook: Webhook) {
		if (!webhook) return
		const indice = this.webhooks.findIndex(existente => existente.id === webhook.id)
		indice === -1
			? this.webhooks = [...this.webhooks, webhook]
			: this.webhooks.splice(indice, 1, webhook)
	}

	criar() {
		this.dialogoDeEdicao.mostrar(criarWebhook(), true)
	}

	editar(indice: number) {
		const webhook = this.webhooks[indice]
		if (!webhook) return
		this.dialogoDeEdicao.mostrar(webhook, false)
	}

	async deletar(indice: number) {
		const webhook = this.webhooks[indice]
		if (!webhook || !webhook.id) return

		const confirmado = await this.confirmacaoExclusao.mostrarComParametros(
			'Excluir webhook?',
			`O webhook <strong>${webhook.url}</strong> será removido permanentemente e deixará de receber notificações.`,
		)
		if (!confirmado) return

		try {
			await this.deleteUseCase.delete(webhook.id)
			this.webhooks = this.webhooks.filter(({ id }) => id !== webhook.id)
			AlertModule.setSuccess('Webhook excluído com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}
}

function criarWebhook(): FormWebhook {
	return {
		id: '',
		url: '',
		secret: '',
		ativo: true,
		descricao: '',
		eventos: [],
	}
}
